/**
 * 邀请 / 协作人链接进入后台：本会话跳过「登录后首次实名认证」主动弹窗。
 * 功能门禁（问卷管理等）仍可按需弹出。
 */
export const SKIP_VERIFICATION_LOGIN_PROMPT_KEY = 'user-verification-skip-invite-entry'

/** 标记当前会话经由邀请/协作人链接进入 */
export function markInviteOrCollaboratorLinkEntry () {
  try {
    sessionStorage.setItem(SKIP_VERIFICATION_LOGIN_PROMPT_KEY, '1')
    return true
  } catch {
    return false
  }
}

/** 是否已标记为邀请/协作人链接进入 */
export function isInviteOrCollaboratorLinkEntry () {
  try {
    return sessionStorage.getItem(SKIP_VERIFICATION_LOGIN_PROMPT_KEY) === '1'
  } catch {
    return false
  }
}

/** 登出时清除标记 */
export function clearInviteOrCollaboratorLinkEntry () {
  try {
    sessionStorage.removeItem(SKIP_VERIFICATION_LOGIN_PROMPT_KEY)
  } catch { /* ignore */ }
}
